export default "<ng-container *ngIf=\"report$\">\n    <app-data-table-list\n        [received]=\"report$\"\n    ></app-data-table-list>\n</ng-container>\n"